module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_h_dark.b894b5f5.svg";